import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProductCard1 = ({ props, discountData }) => {
  const navigate = useNavigate();
  const {
    title,
    img,
    gallary_img,
    unit_price,
    description,
    specification,
    mcq,
    categories,
    stock,
    status,
    _id,
  } = props;

  const [isDiscounted, setIsDiscounted] = useState(false);
  useEffect(() => {
    if (categories.includes(discountData?.category)) setIsDiscounted(true);
  }, [discountData, props]);

  // console.log(isDiscounted);

  const handlePurchase = () => {
    navigate(`/purchase?_id=${_id}`);
  };

  // console.log(props);

  return (
    <div className="flex flex-col justify-center items-center  border border-gray-200">
      <div className="p-1">
        <img className="" src={img} alt="product img" />
      </div>
      <div className="flex flex-col justify-center items-center  p-1 ">
        <div className="rating rating-xs mt-6">
          <input
            type="radio"
            name="rating-5"
            className="mask mask-star-2 bg-orange-400"
          />
          <input
            type="radio"
            name="rating-5"
            className="mask mask-star-2 bg-orange-400"
          />
          <input
            type="radio"
            name="rating-5"
            className="mask mask-star-2 bg-orange-400"
          />
          <input
            type="radio"
            name="rating-5"
            className="mask mask-star-2 bg-orange-400"
          />
          <input
            type="radio"
            name="rating-5"
            className="mask mask-star-2 bg-orange-400"
          />
        </div>
        <p className="my-2 text-sm text-center">{title.slice(0, 25)}..</p>
        <div className="flex lg:flex-row md:flex-row sm:flex-col  justify-center items-center font-bold">
          {isDiscounted ? (
            <p className=" text-red-500 text-xl">
              $
              {isDiscounted
                ? unit_price - (unit_price * discountData?.value) / 100
                : unit_price}
            </p>
          ) : (
            <></>
          )}
          <p className={isDiscounted ? "line-through ml-2" : ""}>
            ${unit_price}
          </p>
        </div>

        <div className="lg:flex-row sm:flex-col justify-evenly gap-1 my-3 flex">
          <button className="btn btn-xs btn-warning">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
              />
            </svg>
          </button>
          <button onClick={handlePurchase} className="btn btn-xs btn-warning">
            Purchase
          </button>
          <button className="btn btn-xs btn-warning">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
        </div>

        {/* <p className="my-1 text-xs text-center">{description.slice(0, 60)}..</p> */}
      </div>
    </div>
  );
};

export default ProductCard1;
